import { render, staticRenderFns } from "./InviteAcceptPage.vue?vue&type=template&id=5b3dc144&scoped=true"
import script from "./InviteAcceptPage.vue?vue&type=script&lang=js"
export * from "./InviteAcceptPage.vue?vue&type=script&lang=js"
import style0 from "./InviteAcceptPage.vue?vue&type=style&index=0&id=5b3dc144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3dc144",
  null
  
)

export default component.exports